"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageWithTitle = void 0;
const pdfTheme_1 = require("../pdfTheme");
const ImageComponent_1 = require("./ImageComponent");
const fontSize = 14;
class ImageWithTitle {
    constructor(imageTitle, imageReference, opts = {}) {
        var _a, _b, _c;
        this.imageTitle = imageTitle;
        this.imageReference = imageReference;
        this.nodes = [];
        const defaultOptions = { width: pdfTheme_1.pdfTheme.page.width, height: pdfTheme_1.pdfTheme.page.height };
        //TODO: clean up pagebreaking logic. we do this here because elsewhere the titlebar is responsible for pagebreaking
        // and we only have a titlebar sometimes
        const pageBreak = opts.pageBreak === 'none' || opts.sectionTitle ? undefined : ((_a = opts.pageBreak) !== null && _a !== void 0 ? _a : defaultOptions.pageBreak);
        this.options = {
            width: (_b = opts.width) !== null && _b !== void 0 ? _b : defaultOptions.width,
            sectionTitle: opts.sectionTitle,
            height: (_c = opts.height) !== null && _c !== void 0 ? _c : defaultOptions.height,
            pageBreak,
        };
        if (this.options.sectionTitle) {
            this.nodes.push(this.options.sectionTitle);
        }
        const headersHeight = (this.options.sectionTitle ? this.options.sectionTitle.height : 0) + fontSize * pdfTheme_1.MAGIC_SCALING_NUMBER;
        this.imageComponent = new ImageComponent_1.ImageComponent(this.imageReference, this.options.width, this.options.height - headersHeight);
        this.nodes.push(this.imageComponent);
    }
    exportContent() {
        return {
            unbreakable: true,
            margin: [0, 0],
            alignment: 'center',
            pageBreak: this.options.pageBreak,
            stack: [
                ...(this.options.sectionTitle ? [this.options.sectionTitle.exportContent()] : []),
                {
                    text: this.imageTitle,
                    style: ['imageTitle'],
                },
                this.imageComponent.exportContent(),
            ],
        };
    }
    exportStyles() {
        return {
            imageTitle: {
                fontSize,
                alignment: 'center',
                color: pdfTheme_1.pdfTheme.font.color.dark,
            },
        };
    }
}
exports.ImageWithTitle = ImageWithTitle;
//# sourceMappingURL=ImageWithTitle.js.map